import Vue from 'vue';
import TextFieldRulesService from './services/text-field.rules.service';

Vue.prototype.$textFieldRulesService = TextFieldRulesService;
